// extracted by mini-css-extract-plugin
export default {"guest-mode-label-wrapper":"GuestModeLabel_guest-mode-label-wrapper__muCC8"};